import { interval } from 'rxjs';
import {
    filter,
    map,
    switchMap,
    withLatestFrom,
    distinctUntilChanged,
} from 'rxjs/operators';

const createConcurrencyIntervalStream = (
    concurrencyStoreUpdate$,
    scheduler,
) =>
    concurrencyStoreUpdate$
        .pipe(
            map(({ updateIntervalMs }) => updateIntervalMs),
            filter(updateIntervalMs => updateIntervalMs > 0),
            distinctUntilChanged(),
            switchMap(updateIntervalMs => interval(updateIntervalMs, scheduler)),
            withLatestFrom(concurrencyStoreUpdate$),
            map(([, latestConcurrency]) => latestConcurrency),
        );

export default createConcurrencyIntervalStream;
